'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { Map as ImmutableMap } from 'immutable';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import formatName from 'I18n/utils/formatName';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getEmailSubject, getTimestamp, getWorkflowId, getRecipientVid } from 'conversations-message-history/crm-object-workflow-email-sent/operators/crmObjectWorkflowEmailSentGetters';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import DashedLabel from '../atoms/DashedLabel';
import { getVerboseDateText } from 'conversations-message-history/util/getVerboseDateText';
import WorkflowLink from './WorkflowLink';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData, getFirstName, getLastName, getEmail } from 'conversations-message-history/senders/operators/getters';
import { VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { jsx as _jsx } from "react/jsx-runtime";
class CrmObjectWorkflowEmailSentMessage extends PureComponent {
  render() {
    const {
      message,
      portalId,
      senders,
      vid,
      recipientVisitors
    } = this.props;
    const recipientVid = getRecipientVid(message);
    const recipientVidString = recipientVid ? recipientVid.toString() : '';
    const recipientVisitor = recipientVisitors.get(recipientVidString);
    const visitorSender = findSender(vid, VISITOR, senders);
    const recipient = recipientVisitor || visitorSender;
    const recipientData = getData(recipient);
    const recipientName = isSucceeded(recipient) ? formatName({
      firstName: getFirstName(recipientData),
      lastName: getLastName(recipientData),
      email: getEmail(recipientData)
    }) : /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
    return /*#__PURE__*/_jsx(DashedLabel, {
      transparent: true,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-inbox-message-history.crm-object-workflow-email-sent.default",
        options: {
          date: getVerboseDateText(getTimestamp(message)),
          emailSubjectWithWorkflowLink: /*#__PURE__*/_jsx(WorkflowLink, {
            portalId: portalId,
            workflowId: getWorkflowId(message),
            emailSubject: getEmailSubject(message)
          }),
          visitorName: recipientName
        }
      })
    });
  }
}
CrmObjectWorkflowEmailSentMessage.displayName = 'CrmObjectWorkflowEmailSentMessage';
CrmObjectWorkflowEmailSentMessage.propTypes = {
  message: RecordPropType('CrmObjectWorkflowEmailSent').isRequired,
  portalId: PropTypes.number.isRequired,
  recipientVisitors: PropTypes.instanceOf(ImmutableMap),
  senders: PropTypes.instanceOf(ImmutableMap).isRequired,
  vid: PropTypes.number
};
CrmObjectWorkflowEmailSentMessage.defaultProps = {
  recipientVisitors: ImmutableMap()
};
export default CrmObjectWorkflowEmailSentMessage;